module.exports = __webpack_public_path__ + "img/freedom_img.f43d5928.png";